import React from 'react';
import { router } from '@inertiajs/react';
import { HiExclamationCircle } from 'react-icons/hi';

interface NoteErrorProps {
  error?: string;
}

const NoteError: React.FC<NoteErrorProps> = ({ error }) => {
  return (
    <div className="flex flex-1 items-center justify-center w-full bg-white dark:bg-gray-900 p-8">
      <div className="max-w-md w-full text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-red-100 dark:bg-red-900/20">
          <HiExclamationCircle className="w-10 h-10 text-red-600 dark:text-red-400" />
        </div>

        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Failed to load note
        </h2>

        <p className="text-gray-600 dark:text-gray-400 mb-6">
          {error || 'Note not found'}
        </p>

        <button
          onClick={() => router.visit('/app')}
          className="inline-flex items-center justify-center px-6 py-2.5 text-sm font-medium text-white bg-primary hover:bg-primary-dark rounded-lg transition-colors"
        >
          Go back to notes
        </button>
      </div>
    </div>
  );
};

export default NoteError;


